/**
 * Announces PLP/search result-count changes to screen readers (WCAG 4.1.3).
 * Nosto intercepts collection filtering/sorting and re-renders the results
 * region client-side -- on some pages it removes [data-products-grid]
 * entirely, so this can't gate on that container existing. Instead it watches
 * the whole results region for any change and re-reads whichever result-count
 * text is present at the time, from whichever of these the current page and
 * renderer happen to keep updated.
 *
 * On a PLP (collection page), result-count announcements are owned by
 * `assets/nosto-facet-keyboard.js` instead, which announces gated on an
 * actual user facet/sort interaction and deduped. This script used to also
 * read `.collection_products_count` for the same information, and its other
 * fallback -- the grid's `data-collection-results-message` attribute -- turns
 * out to be live-updated on PLPs too (a progressive "Viewing 22 of 48
 * products" value as more items lazy-load in). Either one racing the facet
 * script's announcement produced up to three announcements per filter
 * change, including that stale intermediate count, since this script's own
 * 150ms quiet-DOM debounce is frequently denied by Nosto's continuous
 * re-rendering. Nosto replaces the theme's own collection markup wholesale on
 * these pages (sometimes before this script's first DOMContentLoaded check
 * even runs), so a DOM-based "is this a collection page" test is racy; the
 * URL path is not, so `/collections/` in the path is used below to stand this
 * script down there entirely and leave the PLP announcement solely to the
 * facet script. Everywhere else (e.g. the `/search` results page) it's
 * unaffected.
 */
(function () {
  'use strict';

  function createLiveRegion() {
    var region = document.querySelector('[data-collection-results-status]');
    if (region) return region;
    region = document.createElement('div');
    region.className = 'visually-hidden';
    region.setAttribute('role', 'status');
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    region.setAttribute('data-collection-results-status', '');
    document.body.appendChild(region);
    return region;
  }

  function resultsText() {
    var grid = document.querySelector('[data-products-grid][data-collection-results-message]');
    if (grid) return grid.getAttribute('data-collection-results-message');

    var pagination = document.querySelector('.pagination-custom__info');
    if (pagination && pagination.textContent.trim()) return pagination.textContent.trim();

    var searchCaption = document.querySelector('.search__caption');
    if (searchCaption && searchCaption.textContent.trim()) return searchCaption.textContent.trim();

    return null;
  }

  function isCollectionPage() {
    return /^\/collections\//.test(window.location.pathname);
  }

  function init() {
    // Collection pages: the facet script owns the result-count announcement.
    if (isCollectionPage()) return;

    var container = document.querySelector('.collection__products, [data-products-grid], .product-grid-outer');
    if (!container) return;

    var region = createLiveRegion();
    var lastText = resultsText();
    var timer;

    new MutationObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        var text = resultsText();
        if (!text || text === lastText) return;
        lastText = text;
        region.textContent = text;
      }, 150);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
